import React from 'react'
import RightPriceDetailsTabs from './RightPriceDetailsTabs'
import modalLogo from "../assets/Modal-logo-img.png";

import indiaFlag from "../assets/India.png";
import nameIcon from "../assets/Name.png";
import birthIcon from "../assets/BirthDate.png";
import passIcon from "../assets/BoardingPass.png";
import protectIcon from "../assets/Protect.png";
import checkinIcon from "../assets/check-in.png";
import guaranteeIcon from "../assets/Guarantee.png";
import bag1 from "../assets/Bag.png";
import bag2 from "../assets/Bag-02.png";
import bag3 from "../assets/trolly.png";
import insuranceIcon from "../assets/FlightInsurance.png";
import seatIcon from "../assets/Seat.png";
import { Link } from 'react-router-dom';

import visaImg from "../assets/visa.png";
import masterCardImg from "../assets/masterCard.png";
import paypalImg from "../assets/paypal.png";

import { useTranslation } from 'react-i18next'



const DetailsAndPayment = () => {
  const { t } = useTranslation();

  return (
    <>
        <div className="heading-top-form mb-4">
            <div className="top-card-seats p-0 pt-2 pb-1 d-flex align-items-center flex-md-nowrap flex-wrap gap-lg-5 gap-3">
                <div className="left-seat text-center">
                    <img src={modalLogo} alt="Trip Logo" />
                </div>
                <div className="right-seat">
                    <h4>{t("Indore to New Delhi")}</h4>
                    <p className="m-0 p-0">{t("Tue, 9 Sept – Tue, 16 Sept")}</p>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-8 col-md-12 mb-4">
                <div className="card-box mb-4">
                    <div className="trai-box-top-trip d-flex align-items-center gap-2 p-25 border-bottom-box">
                        <h4 className="m-0 p-0">{t("passengerInfo")}</h4>
                    </div>
                    <hr className="line-shap m-0 p-0" />
                    <div className="bottom-from-details-sec p-25">
                        <h5 className="p-0 mb-4">{t("Personal details")}</h5>
                        <ul className="two-part-sec com-par-details-sec d-flex align-items-center gap-2 list-unstyled p-0 m-0 flex-wrap">
                            <li className="d-flex align-items-center gap-2">
                                <img src={nameIcon} alt="name" />
                                <span>{t("nameGender")}</span>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <img src={indiaFlag} alt="id" />
                                <span>{t("idInfo")}</span>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <img src={birthIcon} alt="dob" />
                                <span>13/07/1969</span>
                            </li>
                        </ul>
                        <div className="full-bled-link w-100 d-flex justify-content-end">
                            <button className="btn btn-primary">{t("edit")}</button>
                        </div>
                    </div>
                    <hr className="line-shap m-0 p-0" />
                    <div className="bottom-from-details-sec p-25 position-relative">
                        <ul className="com-par-details-sec d-flex align-items-center gap-2 list-unstyled p-0 m-0 flex-wrap">
                            <li className="d-flex align-items-center gap-2">
                                <img src={checkinIcon} alt="check-in" />
                                <span>{t("automaticCheckin")}</span>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <img src={protectIcon} alt="protection" />
                                <span> {t("disruptionProtection")} </span>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <img src={passIcon} alt="boarding" />
                                <span> {t("liveBoardingPass")} </span>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <img src={guaranteeIcon} alt="premium" />
                                <span> {t("premiumServices")} </span>
                            </li>
                        </ul>
                        <p className="m-0 p-0 fiex-right">{t("included")}</p>
                    </div>
                    <hr className="line-shap m-0 p-0" />
                    <div className="bottom-from-details-sec p-25 position-relative">
                        <h5 className="p-0 mb-4"> {t("baggage")} </h5>
                        <ul className="com-par-details-sec d-flex align-items-center gap-2 list-unstyled p-0 m-0 flex-wrap">
                            <li className="d-flex align-items-center gap-2">
                                <img src={bag1} alt="bag" />
                                <span> {t("personalItem1")} </span>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <img src={bag2} alt="cabin" />
                                <span>{t("cabinBag")}</span>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <img src={bag3} alt="checked" />
                                <span>{t("checkedBag1")}</span>
                            </li>
                        </ul>
                        <div className="full-bled-link w-100 d-flex justify-content-end">
                            <button className="btn btn-primary">{t("edit")}</button>
                        </div>
                    </div>
                    <hr className="line-shap m-0 p-0" />
                    <div className="bottom-from-details-sec p-25 position-relative">
                        <h5 className="p-0 mb-4"> {t("travelInsurance")} </h5>
                        <ul className="com-par-details-sec d-flex align-items-center gap-2 list-unstyled p-0 m-0 flex-wrap">
                            <li className="d-flex align-items-center gap-2">
                                <img src={insuranceIcon} alt="insurance" />
                                <span> {t("noInsurance")} </span>
                            </li>
                        </ul>
                        <div className="full-bled-link w-100 d-flex justify-content-end">
                            <button className="btn btn-primary">{t("edit")}</button>
                        </div>
                    </div>
                    <hr className="line-shap m-0 p-0" />
                    <div className="bottom-from-details-sec p-25 position-relative">
                        <h5 className="p-0 mb-4">{t("seats")}</h5>
                        <ul className="com-par-details-sec d-flex align-items-center gap-2 list-unstyled p-0 m-0 flex-wrap">
                            <li className="d-flex align-items-center gap-2">
                                <img src={seatIcon} alt="seat" />
                                <span> {t("chosenSeat")}</span>
                            </li>
                            <li className="d-flex align-items-center gap-2">
                                <img src={seatIcon} alt="seat" />
                                <span>{t("randomSeat")}</span>
                            </li>
                        </ul>
                        <div className="full-bled-link w-100 d-flex justify-content-end">
                            <button className="btn btn-primary">{t("edit")}</button>
                        </div>
                    </div>
                </div>

                <div className="card-box mb-4">
                    <div className="trai-box-top-trip d-flex align-items-center gap-2 p-25 border-bottom-box">
                        <h4 className="m-0 p-0">{t("contactDetails")}</h4>
                    </div>
                    <hr className="line-shap m-0 p-0" />
                    <div className="bottom-from-details-sec p-25">
                        <div className="row form-box-payment-new">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label>{t("yourEmail")}</label>
                                    <input type="text" className="form-control" placeholder="" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label>{t("Phone Number")} *</label>
                                    <div className="d-flex align-items-center two-form-box">
                                    <div className="helf-box first-helf-box">
                                        <div className="dropdown">
                                            <button className="btn btn-fixed-box d-flex align-items-center gap-1 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src={indiaFlag} alt="India" /> +91
                                            </button>
                                            <ul className="dropdown-menu">
                                                <li>
                                                    <Link className="dropdown-item" to="#">
                                                        <img src={indiaFlag} alt="India" /> +91
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link className="dropdown-item" to="#">
                                                        <img src={indiaFlag} alt="India" /> +91
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="helf-box">
                                        <input type="text" className="form-control" placeholder="" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" id="gridCheck" />
                                <label className="form-check-label" htmlFor="gridCheck">
                                {t("smsUpdate")}
                                </label>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="card-box mb-4">
                    <div className="trai-box-top-trip d-flex align-items-center gap-2 p-25 border-bottom-box">
                        <h4 className="m-0 p-0">{t("addPromo")}</h4>
                    </div>
                    <hr className="line-shap m-0 p-0" />
                    <div className="bottom-from-details-sec p-25">
                        <div className="row form-box-payment-new align-items-end">
                            <div className="col-md-6">
                                <label htmlFor="promoCode">{t("promoCode")}</label>
                                <input type="text" id="promoCode" className="form-control" placeholder="" />
                            </div>
                            <div className="col-md-6">
                                <button className="btn btn-box-small btn-primary">{t("add")}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-box mb-0">
                    <div className="trai-box-top-trip d-flex align-items-center gap-2 p-25 border-bottom-box">
                        <h4 className="m-0 p-0">{t("yourPayment")}</h4>
                    </div>
                    <hr className="line-shap m-0 p-0" />
                    <div className="payment-box-card pt-4 p-25">
                        <h4>{t("howToPay")}</h4>
                        <ul className="list-unstyled p-0 m-0 d-flex align-items-center gap-2">
                            <li>
                                <button className="btn-img">
                                    <img src={visaImg} alt="Visa" />
                                </button>
                            </li>
                            <li>
                                <button className="btn-img">
                                    <img src={masterCardImg} alt="MasterCard" />
                                </button>
                            </li>
                            <li>
                                <button className="btn-img">
                                    <img src={paypalImg} alt="PayPal" />
                                </button>
                            </li>
                        </ul>

                        <div className="row form-box-payment pt-3">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label htmlFor="cardName">{t("cardName")}</label>
                                    <input type="text" id="cardName" className="form-control" placeholder="" />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label htmlFor="cardNumber">{t("cardNumber")}</label>
                                    <div className="position-relative input-icons-box">
                                        <input type="text" id="cardNumber" className="form-control" placeholder="" />
                                        <span className="card-img">
                                            <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.8438 0C23.0327 0 24 0.967312 24 2.15625V14.3438C24 15.5327 23.0327 16.5 21.8438 16.5H2.15625C0.967312 16.5 0 15.5327 0 14.3438V2.15625C0 0.967312 0.967312 0 2.15625 0H21.8438ZM2.15625 1.5C1.79437 1.5 1.5 1.79437 1.5 2.15625V14.3438C1.5 14.7056 1.79437 15 2.15625 15H21.8438C22.2056 15 22.5 14.7056 22.5 14.3438V2.15625C22.5 1.79437 22.2056 1.5 21.8438 1.5H2.15625Z" fill="#717171"/><path d="M17.1421 10.3927C16.9796 10.3927 16.8159 10.3401 16.6783 10.2316C16.353 9.97518 16.2972 9.50362 16.5536 9.17831C16.7639 8.91168 16.875 8.59064 16.875 8.25C16.875 7.90936 16.7639 7.58831 16.5537 7.32164C16.2972 6.99637 16.3531 6.52476 16.6783 6.26831C17.0036 6.01195 17.4752 6.06768 17.7317 6.393C18.1465 6.91931 18.375 7.57879 18.375 8.25C18.375 8.9212 18.1465 9.58068 17.7316 10.107C17.5836 10.2947 17.364 10.3927 17.1421 10.3927Z" fill="#717171"/><path d="M19.0047 12.2545C18.8262 12.2545 18.6472 12.1913 18.504 12.0627C18.1957 11.7861 18.17 11.3119 18.4467 11.0036C19.1262 10.2464 19.5004 9.2685 19.5004 8.25C19.5004 7.2315 19.1262 6.2536 18.4467 5.49638C18.17 5.18808 18.1957 4.71389 18.504 4.43728C18.8123 4.16067 19.2864 4.18627 19.5631 4.49456C20.4899 5.52741 21.0004 6.86114 21.0004 8.25C21.0004 9.63886 20.4899 10.9726 19.5631 12.0054C19.415 12.1705 19.2103 12.2545 19.0047 12.2545Z" fill="#717171"/><path d="M5.8125 3.75C6.74302 3.75 7.5 4.50698 7.5 5.4375V6.5625C7.5 7.49302 6.74302 8.25 5.8125 8.25H4.6875C3.75698 8.25 3 7.49302 3 6.5625V5.4375C3 4.50698 3.75698 3.75 4.6875 3.75H5.8125ZM4.6875 5.25C4.58409 5.25 4.5 5.33409 4.5 5.4375V6.5625C4.5 6.66591 4.58409 6.75 4.6875 6.75H5.8125C5.91591 6.75 6 6.66591 6 6.5625V5.4375C6 5.33409 5.91591 5.25 5.8125 5.25H4.6875Z" fill="#717171"/></svg>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="expiryDate">{t("expiryDate")}</label>
                                    <input type="text" id="expiryDate" className="form-control" placeholder="MM/YY" />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="cvv">{t("cvv")}</label>
                                    <div className="position-relative input-icons-box">
                                        <input type="text" id="cvv" className="form-control" placeholder="" />
                                        <span className="card-img">
                                            <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.8438 0C23.0327 0 24 0.967312 24 2.15625V14.3438C24 15.5327 23.0327 16.5 21.8438 16.5H2.15625C0.967312 16.5 0 15.5327 0 14.3438V2.15625C0 0.967312 0.967312 0 2.15625 0H21.8438ZM2.15625 1.5C1.79437 1.5 1.5 1.79437 1.5 2.15625V14.3438C1.5 14.7056 1.79437 15 2.15625 15H21.8438C22.2056 15 22.5 14.7056 22.5 14.3438V2.15625C22.5 1.79437 22.2056 1.5 21.8438 1.5H2.15625Z" fill="#717171"/><path d="M17.1421 10.3927C16.9796 10.3927 16.8159 10.3401 16.6783 10.2316C16.353 9.97518 16.2972 9.50362 16.5536 9.17831C16.7639 8.91168 16.875 8.59064 16.875 8.25C16.875 7.90936 16.7639 7.58831 16.5537 7.32164C16.2972 6.99637 16.3531 6.52476 16.6783 6.26831C17.0036 6.01195 17.4752 6.06768 17.7317 6.393C18.1465 6.91931 18.375 7.57879 18.375 8.25C18.375 8.9212 18.1465 9.58068 17.7316 10.107C17.5836 10.2947 17.364 10.3927 17.1421 10.3927Z" fill="#717171"/><path d="M19.0047 12.2545C18.8262 12.2545 18.6472 12.1913 18.504 12.0627C18.1957 11.7861 18.17 11.3119 18.4467 11.0036C19.1262 10.2464 19.5004 9.2685 19.5004 8.25C19.5004 7.2315 19.1262 6.2536 18.4467 5.49638C18.17 5.18808 18.1957 4.71389 18.504 4.43728C18.8123 4.16067 19.2864 4.18627 19.5631 4.49456C20.4899 5.52741 21.0004 6.86114 21.0004 8.25C21.0004 9.63886 20.4899 10.9726 19.5631 12.0054C19.415 12.1705 19.2103 12.2545 19.0047 12.2545Z" fill="#717171"/><path d="M5.8125 3.75C6.74302 3.75 7.5 4.50698 7.5 5.4375V6.5625C7.5 7.49302 6.74302 8.25 5.8125 8.25H4.6875C3.75698 8.25 3 7.49302 3 6.5625V5.4375C3 4.50698 3.75698 3.75 4.6875 3.75H5.8125ZM4.6875 5.25C4.58409 5.25 4.5 5.33409 4.5 5.4375V6.5625C4.5 6.66591 4.58409 6.75 4.6875 6.75H5.8125C5.91591 6.75 6 6.66591 6 6.5625V5.4375C6 5.33409 5.91591 5.25 5.8125 5.25H4.6875Z" fill="#717171"/></svg>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="noVouchers" />
                                    <label className="form-check-label" htmlFor="noVouchers">
                                    <strong>
                                        {t("noVouchers")}
                                    </strong>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    
            </div>
            <div className="col-lg-4 col-md-12 mb-4">
                <RightPriceDetailsTabs />
            </div>
        </div>

    </>

  )
}

export default DetailsAndPayment